/**
 * Обёртка над gtag: события только если GA уже инициализирован (после cookie consent).
 */

type GtagEventParams = Record<string, string | number | boolean | undefined>;

function gtagSafe(...args: unknown[]): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag(...args);
}

/** Произвольное событие GA4. */
export function trackEvent(name: string, params: GtagEventParams = {}): void {
  gtagSafe("event", name, params);
}

/** SPA page_view при смене маршрута. */
export function trackPageView(path: string, title?: string): void {
  gtagSafe("event", "page_view", {
    page_path: path,
    page_title: title ?? (typeof document !== "undefined" ? document.title : path),
  });
}

/** Отправка формы заказа / контакта → конверсия generate_lead. */
export function trackGenerateLead(params: {
  form_id: "order_form" | "contact_form";
  service?: string;
}): void {
  trackEvent("generate_lead", {
    form_id: params.form_id,
    service: params.service,
    currency: "USD",
  });
  trackEvent("form_submit", {
    form_id: params.form_id,
    service: params.service,
  });
}

/** Клик по email / telegram / phone. */
export function trackContactClick(channel: "email" | "telegram" | "phone" | "form_anchor"): void {
  trackEvent("contact_click", { channel });
  if (channel === "telegram") trackEvent("click_telegram", { channel });
  if (channel === "phone") trackEvent("click_phone", { channel });
  if (channel === "email") trackEvent("click_email", { channel });
}

/** CTA на услуги / пакеты. */
export function trackCtaClick(cta_id: string, page?: string): void {
  trackEvent("click_cta", { cta_id, page: page ?? (typeof location !== "undefined" ? location.pathname : "") });
}

/** Переход в биллинг / заказ VPS. */
export function trackBillingClick(plan?: string, destination?: string): void {
  trackEvent("click_billing_order", {
    plan: plan ?? "unknown",
    destination: destination ?? "billing",
  });
}
